import { Outlet } from '@tanstack/react-router';

import { Header } from './header';
import { Sidebar } from './sidebar';

export const AppShell = () => (
  <div className="flex h-screen">
    <Sidebar />
    <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
      <Header />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  </div>
);
